<template>
  <!----------------------------------------- LABOUR COMPONENT  ------------------------------->
  <div>
    <!--------------------Remove & Refit ----------------------->
    <div class="mb-5"
      v-if="selectedTab.type == ItemCategoryTypes.RR || selectedViewType != viewTypes.tabbedView">
      <quote-builder-labour-headings-component :name="rrCategory?.displayName || 'Remove & Refit'"
        :is-full-width="isFullWidth"
        :is-quote-hour="isQuoteTypeHour"
        :count="rrLength"
        :total-value="rrTotal"
        :hour-value="rrHourTotal"
        :is-ntar="isNtar"
        :next-line-number="nextLineNumber" />
      <div class="rows">
        <draggable @change="itemMoved($event, ItemCategoryTypes.RR)"
          v-model="innerValue.labours"
          @over.prevent
          @enter.prevent
          v-bind="{'disabled': !isRowDraggable, ghostClass: 'draggable-ghost', dragClass: 'draggable-drag'}"
          :clone="$event => cloneHandler($event, ItemCategoryTypes.RR)"
          :group="{ name: ItemCategoryTypes.RR, pull: 'clone', put: true }"
          handle=".item-drag-handle">
          <div v-for="item in innerValue.labours"
            :key="item.quoteItemId + ItemCategoryTypes.RR">
            <quote-builder-labour-item :read-only-view="readOnlyView"
              v-if="item.itemType == ItemCategoryTypes.RR"
              :vehicle="vehicle"
              :inner-value="innerValue"
              :items-assessments="itemsAssessments"
              :is-quote-type-hour="isQuoteTypeHour"
              :is-full-width="isFullWidth"
              :item="item"
              :is-selected="editItemObj.id === item.quoteItemId"
              :fully-expanded="editItemObj.isFullyExpanded"
              :is-ntar="isNtar"
              :next-line-number="nextLineNumber"
              :is-editable="!readOnlyComputed"
              @deleteItem="deleteItem"
              @updateValue="updateValue"
              @focusNextRow="id => $emit('focusNextRow', item)"
              @handlePresentAs="itemId => $emit('handlePresentAs', itemId)"
              @itemRowClicked="(value, event, expand, close) => $emit('handleItemRowClick',value, event, expand, close)" />
          </div>
        </draggable>
      </div>
      <div>
        <button class="button is-outlined is-primary"
          @click="addBlankItem($event, ItemCategoryTypes.RR)"
          :disabled="readOnlyComputed">
          + Add Item
        </button>
      </div>
    </div>
    <!-----------------------REPAIR ----------------------->
    <div class="mb-5"
      v-if="selectedTab.type == ItemCategoryTypes.REP || selectedViewType != viewTypes.tabbedView">
      <quote-builder-labour-headings-component :name="repCategory?.displayName || 'Repair'"
        :is-full-width="isFullWidth"
        :is-quote-hour="isQuoteTypeHour"
        :count="repLength"
        :total-value="repairTotal"
        :hour-value="repairHourTotal"
        :is-ntar="isNtar"
        :show-loading="isNtar"
        :next-line-number="nextLineNumber" />
      <div class="rows">
        <draggable @change="itemMoved($event, ItemCategoryTypes.REP)"
          v-model="innerValue.labours"
          @over.prevent
          @enter.prevent
          :clone="$event => cloneHandler($event, ItemCategoryTypes.REP)"
          :group="{ name: ItemCategoryTypes.REP, pull: 'clone', put: true }"
          v-bind="{'disabled': !isRowDraggable, chosen: 'chosen', ghostClass: 'draggable-ghost', dragClass: 'draggable-drag'}"
          handle=".item-drag-handle">
          <div v-for="item in innerValue.labours"
            :key="item.quoteItemId + ItemCategoryTypes.REP">
            <quote-builder-labour-item :inner-value="innerValue"
              v-if="item.itemType == ItemCategoryTypes.REP"
              :read-only-view="readOnlyView"
              :items-assessments="itemsAssessments"
              :vehicle="vehicle"
              :is-full-width="isFullWidth"
              :is-quote-type-hour="isQuoteTypeHour"
              :item="item"
              :is-selected="editItemObj.id === item.quoteItemId"
              :fully-expanded="editItemObj.isFullyExpanded"
              :show-loading="isNtar"
              :is-ntar="isNtar"
              :next-line-number="nextLineNumber"
              :is-editable="!readOnlyComputed"
              @deleteItem="deleteItem"
              @updateValue="updateValue"
              @focusNextRow="id => $emit('focusNextRow', item)"
              @handlePresentAs="itemId => $emit('handlePresentAs', itemId)"
              @itemRowClicked="(value, event, expand, close) => $emit('handleItemRowClick',value, event, expand, close)" />
          </div>
        </draggable>
      </div>
      <div>
        <button class="button is-outlined is-primary"
          @click="addBlankItem($event, ItemCategoryTypes.REP)"
          :disabled="readOnlyComputed">
          + Add Item
        </button>
      </div>
    </div>
    <!----------------------PAINT ----------------------->
    <div class="mb-5"
      v-if="selectedTab.type == ItemCategoryTypes.PAINT || selectedViewType != viewTypes.tabbedView">
      <quote-builder-labour-headings-component :name="paintCategory?.displayName || 'Paint'"
        :is-quote-hour="isQuoteTypeHour"
        :is-paint-item="true"
        :count="paintLength"
        :total-value="paintTotal"
        :hour-value="paintHourTotal"
        :is-full-width="isFullWidth"
        :is-ntar="isNtar"
        :next-line-number="nextLineNumber" />

      <div class="rows">
        <draggable @change="itemMoved($event, ItemCategoryTypes.PAINT)"
          v-model="innerValue.labours"
          @over.prevent
          @enter.prevent
          :clone="$event => cloneHandler($event, ItemCategoryTypes.PAINT)"
          :group="{ name: ItemCategoryTypes.PAINT, pull: 'clone', put: true }"
          v-bind="{'disabled': !isRowDraggable, chosen: 'chosen', ghostClass: 'draggable-ghost', dragClass: 'draggable-drag'}"
          handle=".item-drag-handle">
          <div v-for="item in innerValue.labours"
            :key="item.quoteItemId">
            <quote-builder-labour-item v-if="item.itemType == ItemCategoryTypes.PAINT"
              :inner-value="innerValue"
              :is-quote-type-hour="isQuoteTypeHour"
              :is-full-width="isFullWidth"
              :vehicle="vehicle"
              :items-assessments="itemsAssessments"
              :read-only-view="readOnlyView"
              :item="item"
              :is-paint="true"
              :is-selected="editItemObj.id === item.quoteItemId"
              :fully-expanded="editItemObj.isFullyExpanded"
              :is-ntar="isNtar"
              :next-line-number="nextLineNumber"
              :is-editable="!readOnlyComputed"
              @deleteItem="deleteItem"
              @onOpgCodeChanged="$emit('onOpgCodeChanged')"
              @updateValue="updateValue"
              @focusNextRow="id => $emit('focusNextRow', item)"
              @handlePresentAs="itemId => $emit('handlePresentAs', itemId)"
              @itemRowClicked="(value, event, close) => $emit('handleItemRowClick',value, event, close)" />
          </div>
        </draggable>
      </div>
      <div>
        <button class="button is-outlined is-primary"
          @click="addBlankItem($event, ItemCategoryTypes.PAINT)"
          :disabled="readOnlyComputed">
          + Add Item
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import QuoteBuilderLabourHeadingsComponent from './QuoteBuilderLabourHeadingsComponent.vue'
import QuoteBuilderLabourItem from './QuoteBuilderLabourItem.vue'
import { ItemCategoryTypes, LabourTimeTypes, PaintGroupTypes, QuotingMethodTypes, QuoteItemRevTypes, EventHubTypes } from '@/enums'
import draggable from 'vuedraggable'
import { QuoteItemModel } from '@/classes/viewmodels'
import { roundAwayFromZero } from '@/components/utils/AccountingFunctions'
import { QuoteTotalsMethodMixin, QuoteAssessmentMixin, QuoteItemValidationMixin, QuoteLabourMixin, QuoteItemAutoSaveDeleteMixin } from '../../mixins'
import { cloneDeep } from 'lodash'
import _cloneDeep from 'lodash/cloneDeep'
import Guid from '@/components/Guid'

export default {
  name: 'QuoteBuilderLabourComponent',
  components: {
    QuoteBuilderLabourHeadingsComponent,
    QuoteBuilderLabourItem,
    draggable
  },
  mixins: [QuoteTotalsMethodMixin, QuoteAssessmentMixin, QuoteItemValidationMixin, QuoteLabourMixin, QuoteItemAutoSaveDeleteMixin],
  props: {
    value: {
      type: Object,
      required: true
    },
    isFullWidth: {
      type: Boolean,
      required: true
    },
    editItemObj: {
      type: Object
    },
    selectedTab: {
      type: Object
    },
    selectedViewType: {
      type: String
    },
    viewTypes: {
      type: Object
    },
    vehicle: {
      type: Object
    },
    readOnlyView: {
      type: Boolean
    },
    nextLineNumber: {
      type: Number,
      default: 0
    },
    isAudanet: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      innerValue: null,
      isSyncingParentUpdate: false,
      lastEmittedLaboursSignature: null
    }
  },

  computed: {
    ItemCategoryTypes() {
      return ItemCategoryTypes
    },
    LabourTimeTypes() {
      return LabourTimeTypes
    },
    PaintGroupTypes() {
      return PaintGroupTypes
    },
    isRowDraggable() {
      return !this.readOnlyComputed
    },
    QuotingMethodTypes() {
      return QuotingMethodTypes
    },
    isQuoteTypeHour() {
      return this.innerValue.quotingMethod === QuotingMethodTypes.Hour
    },
    rrTotal() {
      return this.calculateItemCategoryTotal(this.innerValue.quotingMethod, this.innerValue.labours, ItemCategoryTypes.RR)
    },
    repairTotal() {
      return this.calculateItemCategoryTotal(this.innerValue.quotingMethod, this.innerValue.labours, ItemCategoryTypes.REP)
    },
    paintTotal() {
      return this.calculateItemCategoryTotal(this.innerValue.quotingMethod, this.innerValue.labours, ItemCategoryTypes.PAINT)
    },
    rrHourTotal() {
      return this.calculateItemCategoryHourTotal(this.innerValue.labours, ItemCategoryTypes.RR)
    },
    repairHourTotal() {
      return this.calculateItemCategoryHourTotal(this.innerValue.labours, ItemCategoryTypes.REP)
    },
    paintHourTotal() {
      return this.calculateItemCategoryHourTotal(this.innerValue.labours, ItemCategoryTypes.PAINT)
    },
    isNtar() {
      return (
        this.innerValue.labourType === LabourTimeTypes.NTAR ||
        this.innerValue.labourType === LabourTimeTypes.LTAR ||
        this.innerValue.labourType === LabourTimeTypes.eMTA
      )
    },
    itemsAssessments() {
      return this.getItemsAssessments(this.innerValue.labours, this.innerValue.quoteAssessments)
    },
    rrLength() {
      return this.innerValue.labours.filter((i) => i.itemType === ItemCategoryTypes.RR && !(i.deleted || i.isDeleted)).length
    },
    repLength() {
      return this.innerValue.labours.filter((i) => i.itemType === ItemCategoryTypes.REP && !(i.deleted || i.isDeleted)).length
    },
    paintLength() {
      return this.innerValue.labours.filter((i) => i.itemType === ItemCategoryTypes.PAINT && !(i.deleted || i.isDeleted)).length
    },
    itemCategoryNames() {
      return this.$company.itemCategories
    },
    rrCategory() {
      return this.itemCategoryNames.find((i) => i.itemCategoryType === ItemCategoryTypes.RR)
    },
    repCategory() {
      return this.itemCategoryNames.find((i) => i.itemCategoryType === ItemCategoryTypes.REP)
    },
    paintCategory() {
      return this.itemCategoryNames.find((i) => i.itemCategoryType === ItemCategoryTypes.PAINT)
    },
    readOnlyComputed() {
      return this.innerValue.readOnly || !this.isEditable
    }
  },
  watch: {
    value: {
      handler(newVal) {
        if (!newVal) return
        const currentSignature = this.computeLaboursSignature(newVal.labours)
        if (this.isSyncingParentUpdate && currentSignature === this.lastEmittedLaboursSignature) {
          // Our own emit came back from the parent — no need to re-clone innerValue
          this.isSyncingParentUpdate = false
          return
        }
        // Fast-path: if labours and key shared fields didn't change, skip the expensive
        // deepDiff(entire_entity). This fires when a sibling (Parts, Misc, etc.) emits
        // and QuoteView recalculates derived totals (paintTotal, rrTotal, etc.) on entity,
        // which changes the entity reference but not the labours array.
        const innerLaboursSignature = this.computeLaboursSignature(this.innerValue?.labours)
        if (currentSignature === innerLaboursSignature &&
            this.innerValue?.quotingMethod === newVal.quotingMethod &&
            this.innerValue?.readOnly === newVal.readOnly) {
          return
        }
        this.innerValue = cloneDeep(newVal)
      },
      deep: true
    },
    innerValue: {
      handler(newVal) {
        if (!newVal || this.isSyncingParentUpdate) return
        const nextSignature = this.computeLaboursSignature(newVal.labours)
        if (nextSignature === this.lastEmittedLaboursSignature) return
        this.lastEmittedLaboursSignature = nextSignature
        this.isSyncingParentUpdate = true
        // Merge with latest parent value to avoid emitting stale sibling arrays (Parts, Misc, etc.) when only labours changed.
        const toEmit = { ...this.value, labours: cloneDeep(newVal.labours) }
        this.$emit('handleUpdate', toEmit)
      },
      deep: true
    }
  },
  created() {
    this.innerValue = cloneDeep(this.value)
    this.lastEmittedLaboursSignature = this.computeLaboursSignature(this.value?.labours)
    // Value is committed to vm.entity after the field's model-update delay.
    // The item watcher in QuoteView triggers autosave once the value propagates.
    this.$watch('innerValue', function () {
    }, { deep: true })
  },
  mounted() {
    this.$v.entity.labours.$touch()
    this.$eventHub.$on('updateLabour', this.updateLabour)
    this.$eventHub.$on('addBlankItemLabour', this.addBlankItem)
    this.$eventHub.$on('deleteLabour', this.deleteItem)
  },
  beforeDestroy() {
    this.$eventHub.$off('updateLabour', this.updateLabour)
    this.$eventHub.$off('addBlankItemLabour', this.addBlankItem)
    this.$eventHub.$off('deleteLabour', this.deleteItem)
  },
  methods: {
    computeLaboursSignature(items = []) {
      try {
        return JSON.stringify(items)
      } catch (e) {
        return null
      }
    },
    updateLabour() {
      const newItems = this.innerValue.labours.filter((i) => i.isNew)

      this.innerValue = cloneDeep(this.value)

      // if there are new items, add them to the innerValue
      if (newItems.length) {
        newItems.forEach((item) => {
          // check if the item already exists in the innerValue
          const existingItem = this.innerValue.labours.find((i) => i.itemDesc === item.itemDesc && i.itemNo === item.itemNo)
          if (!existingItem && item.quoteItemId == this.editItemObj.id ) {
            // if it doesn't exist, add it
            this.innerValue.labours.push(item)
          }
        })
      }

      // check if there are any items in innervalue that are not in value

      // compare two objects, sometimes this function may be called internally
      // and we don't want to update the value twice
      // const diff = deepDiff(this.innerValue, this.value)
      // if (diff) {
      //   // check if there are any changes in the labours array from parent/child components
      //   const haslaboursDiff = diff.some((d) => d.path && d.path[0] === 'labours')

      //   const newInnerValue = cloneDeep(this.value)

      //   // if parent/child labour arrays are different, merge them
      //   if (haslaboursDiff) {
      //     // items that exist in child but not in parent (could be added when tabbing, enter or arrow down)
      //     const newLabourItems = this.innerValue.labours.filter((i) => i.isNew)
      //     // if these items don't exist in the new value, add them
      //     newLabourItems.forEach((item) => {
      //       if (!newInnerValue.labours.find((i) => i.itemDesc === item.itemDesc && i.itemNo === item.itemNo)) {
      //         newInnerValue.labours.push(item)
      //       }
      //     })
      //   }

      //   this.innerValue = newInnerValue
      // }
    },
    cloneHandler(item, type) {
      // change the quoteItemId to a new guid so we can find it later and change to correct type on drop
      // TODO: looks like this doesn't work, leave it as is
      // item.quoteItemId = Guid.newGuid()
      return item
    },
    itemMoved(event, type) {
      // if an item was dragged from one list to another, i.e from RR to RWA, Parts to RR etc.
      if (event?.added) {
        const item = event.added.element
        this.handleItemAdded(item, type, event.added.newIndex)
      }
      let sortNo = this.innerValue.labours.length ? Math.min(...this.innerValue.labours.map((i) => i.sortNo || 1)) : 1
      this.innerValue.labours.forEach((item) => {
        item.sortNo = sortNo
        sortNo++
      })
      this.$eventHub.$emit(EventHubTypes.AutoSaveQuoteItems)
      // Emit directly — don't rely on the deep watcher to detect in-place sortNo mutations
      const nextSignature = this.computeLaboursSignature(this.innerValue.labours)
      this.lastEmittedLaboursSignature = nextSignature
      this.isSyncingParentUpdate = true
      this.$emit('handleUpdate', { ...this.value, labours: cloneDeep(this.innerValue.labours) })
      this.$nextTick(() => { this.isSyncingParentUpdate = false })
    },
    handleItemAdded(item, type, index) {
      const newItem = this.generateItem(item.itemNo, item.itemDesc, item.hourValue, item.rate, type)

      newItem.lineNumber = !this.isAudanet ? this.nextLineNumber : 0

      // replace the item with the new item
      this.innerValue.labours.splice(index, 1, newItem)
      this.$emit('onItemCopied', newItem)
    },
    addBlankItem(event, type) {
      // this is to prevent outside click event from firing, which collpases all the items
      event?.stopPropagation()
      let hour = 0
      let rate = 0
      // const type = ItemCategoryTypes.RR
      switch (type) {
        case ItemCategoryTypes.RR:
          rate = this.isNtar
            ? this.innerValue.shopRate
            : this.getLabourRate(ItemCategoryTypes.RR, this.innerValue.rates, this.innerValue.shopRate, this.innerValue.quoteId).rate
          break
        case ItemCategoryTypes.RWA:
          rate = this.isNtar
            ? this.innerValue.shopRate
            : this.getLabourRate(ItemCategoryTypes.RWA, this.innerValue.rates, this.innerValue.shopRate, this.innerValue.quoteId).rate
          break
        case ItemCategoryTypes.REP:
          rate = this.isNtar
            ? this.innerValue.shopRate
            : this.getLabourRate(ItemCategoryTypes.REP, this.innerValue.rates, this.innerValue.shopRate, this.innerValue.quoteId).rate
          break
        case ItemCategoryTypes.PAINT:
          rate = this.isNtar
            ? this.innerValue.shopRate
            : this.getLabourRate(this.vehicle.paintGroup, this.innerValue.rates, this.innerValue.shopRate, this.innerValue.quoteId).rate
          break
        default:
      }
      const newItem = this.generateItem('', '', hour, rate, type)

      this.innerValue.labours.splice(this.innerValue.labours.length, 1, newItem)
      this.innerValue.lines = this.nextLineNumber + 1
      this.$notification.success('', 'Item added')

      this.$nextTick(() => {
        this.$emit('newItemAdded', newItem.quoteItemId)
      })
    },
    getLabourRate(code, rates, shopRate, quoteId) {
      if (!rates) {
        return {}
      }
      const isPaintType = Object.values(PaintGroupTypes).some((p) => p === code)
      const codeType = isPaintType ? ItemCategoryTypes.PAINT : code
      let rate = this.isNtar ? rates[0] : rates.find((i) => i.labourCodeId === code)
      if (!rate) {
        const labourType = this.$labourTypes.find((t) => t.labourTypeCode === codeType)
        if (!labourType) return { rate: 0 }
        const newRate = {
          quoteId: quoteId,
          labourCodeId: code,
          labourTypeId: labourType.labourTypeId,
          rate: this.isNtar ? shopRate : 0,
          modifiedBy: '',
          modifiedDate: null,
          createdBy: '',
          createdDate: null,
          isNew: true,
          quoteVersion: 0,
          deleted: false
        }
        rates.push(newRate)
        rate = newRate
      }
      return rate
    },
    generateItem(itemNo, description, hourValue, rate, type) {
      let newItem = new QuoteItemModel(this.innerValue.quoteId, itemNo, description, type)
      newItem.lineNumber = !this.isAudanet ? this.nextLineNumber : 0
      newItem.itemNo = itemNo ? itemNo : this.$filters.pad(newItem.lineNumber, 4)
      newItem.hourValue = this.innerValue.quotingMethod === QuotingMethodTypes.Hour ? hourValue : roundAwayFromZero(hourValue * rate)
      newItem.rate = rate
      newItem.dollarValue = roundAwayFromZero(hourValue * rate)
      newItem.opgCode = this.vehicle.paintGroup
      newItem.sortNo = this.innerValue.labours.length ? Math.max(...this.innerValue.labours.map((i) => i.sortNo)) + 1 : 1
      return newItem
    },
    updateValue(item) {
      if (this.innerValue.quotingMethod === QuotingMethodTypes.Dollar) {
        item.dollarValue = item.hourValue
      } else {
        item.dollarValue = roundAwayFromZero(item.hourValue * item.rate)
        if (this.getLabourRateEx(item).rate === item.rate) {
          item.rev = QuoteItemRevTypes.Normal
        } else {
          item.rev = QuoteItemRevTypes.SpecRate
        }
      }

      this.addUpdateRepairPaintLoading(item)
      // this.updateTotal()
    },
    deletePaintLoading(item) {
      if (this.isNtar && Guid.validGuid(item.linkedItemId)) {
        const linkedItem = this.innerValue.labours.find((i) => i.quoteItemId === item.linkedItemId && i.isLoadItem && !i.deleted)
        const index = this.innerValue.labours.findIndex((i) => i.quoteItemId === item.linkedItemId && i.isLoadItem && !i.deleted)
        if (linkedItem) {
          this.deleteItem(linkedItem, index)
        }
      }
    },
    deleteItem(item) {
      this.deletePaintLoading(item)
      const deletedItem = _cloneDeep(item)
      if (item.isNew) {
        const itemIndex = this.innerValue.labours
          .map(function (obj) {
            return obj.quoteItemId
          })
          .indexOf(item.quoteItemId)
        if (itemIndex >= 0) {
          this.innerValue.labours.splice(itemIndex, 1)
          // this.items.splice(index, 1)
        }
      } else {
        this.autoSaveDeleteExistingItem(item)
      }
      this.addUpdateRepairPaintLoading(deletedItem)

      // Sync the deletion into the Add-Item panel so it isn't re-added.
      this.$eventHub.$emit(EventHubTypes.QuoteItemDeletedSync, item)

      // Propagate the deletion to the parent directly (mirrors itemMoved) rather than
      // relying on the innerValue watcher, which drops emits while isSyncingParentUpdate
      // is true — otherwise a later value echo resets innerValue and resurrects the item.
      this.lastEmittedLaboursSignature = this.computeLaboursSignature(this.innerValue.labours)
      this.isSyncingParentUpdate = true
      this.$emit('handleUpdate', { ...this.value, labours: cloneDeep(this.innerValue.labours) })
      this.$nextTick(() => { this.isSyncingParentUpdate = false })

      this.$emit('onItemDeleted', item.lineNumber)

      // this.$toast.open({
      //   message: `Item <span class="is-italic">${item.itemDesc}</span> deleted`,
      //   type: 'is-danger',
      //   position: 'is-top',
      //   actionText: 'Undo',
      //   onAction: () => {
      //     if (item.isNew) {
      //       this.innerValue.labours.splice(this.innerValue.labours.length, 1, item)
      //       // this.items.splice(this.items.length, 1, item)
      //     } else {
      //       item.deleted = false
      //       item.isDeleted = false
      //       item.itemStatus = originalItemStatus
      //     }
      //     // this.updateTotal()
      //   }
      // })
    },
    calculateItemCategoryTotal(quotingMethod, items, itemType) {
      let total = 0
      if (itemType === ItemCategoryTypes.PART) {
        total = items
          // eslint-disable-next-line no-unexpected-multiline
          .filter((i) => !i.deleted && !i.reportOnly)
          .reduce(function (total, item) {
            return roundAwayFromZero(total + item.itemQuantity * item.markupValue)
          }, 0)
      } else if (itemType === ItemCategoryTypes.MISC) {
        total = items
          // eslint-disable-next-line no-unexpected-multiline
          .filter((i) => !i.deleted && !i.reportOnly)
          .reduce(function (total, item) {
            return total + item.value
          }, 0)
      } else if (itemType === ItemCategoryTypes.OPG) {
        total = items
          // eslint-disable-next-line no-unexpected-multiline
          .filter((i) => !i.deleted && !i.reportOnly)
          .reduce(function (total, item) {
            return total + (quotingMethod === QuotingMethodTypes.Dollar ? item.dollarValue : item.hourValue * item.rate)
          }, 0)
      } else if (itemType === ItemCategoryTypes.SUBL) {
        total = items
          // eslint-disable-next-line no-unexpected-multiline
          .filter((i) => !i.deleted && !i.reportOnly)
          .reduce(function (total, item) {
            return total + item.value
          }, 0)
      } else {
        total = items
          // eslint-disable-next-line no-unexpected-multiline
          .filter((i) => !i.deleted && !i.reportOnly && i.itemType === itemType)
          .reduce(function (total, item) {
            return roundAwayFromZero(total + item.dollarValue)
          }, 0)
      }
      return total
    },
    calculateItemCategoryHourTotal(items, itemType) {
      return items
        .filter((i) => !i.deleted && !i.reportOnly && i.itemType === itemType)
        .reduce(function (total, item) {
          return roundAwayFromZero(total + item.hourValue)
        }, 0)
    }
  }
}
</script>
